/** Parse comma-separated print_material ids stored in `parts.material`. */
export function parsePartMaterialIds(raw: string | null | undefined): number[] {
  const v = String(raw ?? "").trim();
  if (!v) return [];
  const out: number[] = [];
  for (const part of v.split(/[,;]/)) {
    const s = part.trim();
    if (!/^\d+$/.test(s)) continue;
    const n = Number(s);
    if (Number.isFinite(n) && n > 0 && !out.includes(n)) out.push(n);
  }
  return out;
}

export function serializePartMaterialIds(ids: number[]): string {
  const uniq = Array.from(
    new Set(ids.filter((n) => Number.isFinite(n) && n > 0)),
  ).sort((a, b) => a - b);
  return uniq.join(",");
}
